module.exports = __webpack_public_path__ + "static/img/2.6085ac6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/sku/包包/2.png
// module id = rpR5
// module chunks = 0